const text = {
  locaText: `국내외 가맹점 최대 <strong>1% 할인은 기본</strong><br>
        세트 발급으로 <strong class="gold">생활패턴에 맞는<br>추가 할인까지</strong>`,
  coffeeText: `국내외 가맹점 최대 <strong>1% 할인은 기본</strong><br>
        <strong class="gold">스타벅스 50%,<br>유튜브 20% 할인까지</strong>`,
  autoText: `국내외 가맹점 최대 <strong>1% 할인은 기본</strong><br>
        <strong class="gold">주유, 배달앱<br>추가 할인까지</strong>`,
  eduText: `국내외 가맹점 최대 <strong>1% 할인은 기본</strong><br>
        <strong class="gold">교육, 서점<br>연 최대 36만원 할인까지</strong>`,
  healthText: `국내외 가맹점 최대 <strong>1% 할인은 기본</strong><br>
        <strong class="gold">병원 10%<br>백화점 5% 할인까지</strong>`,
  shoppingText: `국내외 가맹점 최대 <strong>1% 할인은 기본</strong><br>
        <strong class="gold">쇼핑<br>연 최대 60만원 할인까지</strong>`
}

export default text
